import { TokenAsset } from '@types';
import { isAmountZeroEquivalent } from '@lib/utils';

interface ShouldRenderSummaryParams {
  amount: string;
  connectedWalletsCount: number;
  tokenAsset: TokenAsset | null;
}

function useShouldRenderSummary({
  amount,
  connectedWalletsCount,
  tokenAsset,
}: ShouldRenderSummaryParams): boolean {
  return Boolean(
    connectedWalletsCount > 0 &&
      amount &&
      !isAmountZeroEquivalent(amount) &&
      tokenAsset
  );
}

export default useShouldRenderSummary;
